import { buildMainChatLayoutProps } from './buildMainChatLayoutProps'

/** @param {object} m @param {object} handlers */
export function buildMainLayoutPropsObject(m, handlers) {
  return buildMainChatLayoutProps(m, handlers)
}
